import { useAuthStore } from '../../stores/auth'

function withTimeout(promise, ms) {
    const timeout = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Guard timeout')), ms)
    )
    return Promise.race([promise, timeout])
}

export async function authGuard(to, from, next) {
    const authStore = useAuthStore()

    // Wait for auth initialization (max 3 seconds)
    if (!authStore.isInitialized) {
        try {
            await withTimeout(authStore.initialize(), 3000)
        } catch (error) {
            console.warn('[AuthGuard] Auth initialization timeout')
        }
    }

    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth !== false)
    const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin)

    // 403 Forbidden: 인증은 됐는데 정책 위반 — 풀 리로드(login 사이클)로 가지 말고
    // SPA 안에서 error 페이지로 한 번만 이동. 무한 reload 차단.
    if (requiresAuth && authStore.isAccessForbidden) {
        if (to.name !== 'error') {
            next({ name: 'error', query: { message: 'unauthorized' } })
            return
        }
        next()
        return
    }

    // Check if authentication is required
    if (requiresAuth && !authStore.isAuthenticated) {
        // Redirect to AdminUI/Account/Login to trigger OIDC authentication
        // AccountController has [Authorize] attribute, so it will redirect to IdentityServer
        const returnUrl = encodeURIComponent(to.fullPath)
        window.location.href = `/AdminUI/Account/Login?returnUrl=${returnUrl}`
        return
    }

    // Check if admin role is required
    if (requiresAdmin && !authStore.isAdmin) {
        next({ name: 'error', query: { message: 'unauthorized' } })
        return
    }

    next()
}
